<template>
    <div class="page page-pai_hang_bang pr" >
        <div class="top">
            抽奖记录
        </div>
        <div class="list">
            <div class="list-item list-title clearfix" >
                <div class="el index">抽奖时间</div>
                <div class="el points">奖品</div>
            </div>
            <div class="list-item clearfix" v-for="(item, index) in list" :key='index'>
                <div class="el index to">
                    {{item.createTime}}
                </div>
                <div class="el points">{{item.giftName}}</div>
            </div>
            
        </div>
        <div class="btn-box" >
            <div class="button" v-if='isHaveMore' @click="onGetMore"><i class="el-icon-loading" v-if="isLoading"></i> 加载更多</div>
            <div class="button" v-else @click="onGotoHome"> 没有更多记录了，继续做任务</div>
        </div>
        
    </div>
</template>

<script>
import api from '@/assets/js/api'
import { cookie } from '@/assets/js/utils'
    export default {
        name: "notice",
        data() {
            return {
                actId: 1,
               list: [],
               isLoading: false,
               pageNo: 1,
               isHaveMore: true,
               pageSize: 10
            }
        },
        methods: {
            onGotoHome(){
                this.$router.push('/')
            },

            
            async onload(){
                let self = this;
                let token = cookie.get('token'+self.actId);
                if(!token){
                    self.$message({
                        message: '请先登录'
                    })
                    self.$router.push('/')
                }
                self.isLoading = true;
                let res = await api({
                    method: 'myRunNote',
                    token,
                    pageNo: self.pageNo,
                    pageSize: self.pageSize
                }).catch(err => {
                    // console.log(err)
                })
                let {data, code ,msg} = res && res.data;
                // console.log(data, code ,msg)
                self.isLoading = false;
                if(code ==200){
                    if(self.pageNo == 1){
                        self.list = data.items;
                    }else{
                        self.list = self.list.concat(data.items);
                    }
                    self.isHaveMore = !(self.list.length >= data.total);

                }
                // console.log(self.list)
            },
            onGetMore(){
                let self = this;
                self.pageNo ++;
                self.onload();
            }
        },
        mounted() {
            let self =this;
            self.actId = self.query && self.query.__sa || 1;
            this.onload()
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import '../../assets/css/base.less';
.btn-box {
    width: unit(690 / @page-width * 100, vw);
    margin: 20px auto;

}
.page-pai_hang_bang {
    padding-top: 40px;
}
.top {
    text-align: center;
    padding-bottom: 20px;
    color: @c-red;
    margin: 0 auto;
    width: unit(690 / @page-width * 100, vw);
    background-color: @c-bg;
    padding: unit(35 / @page-width * 100, vw);
    border-radius: 10px;
    margin-bottom: 20px;
    font-size: 28px;
}

.list {
    
    color: #6d5653 !important;
    box-sizing: border-box;
    background-color: #ead7b9;
    margin: 0 auto;
    width: unit(690 / @page-width * 100, vw);
    background-color: @c-bg;
    padding: unit(35 / @page-width * 100, vw);
    border-radius: 10px;
    .list-title {
        .index {
            width:unit(690 / @page-width * 100, vw);
        }
        .points {
            color: #6d5653 !important;
        }
    }
    .list-item {
        &:last-child {
            border: 0;
        }
        // padding: 10px 0;
        .mr {
            margin-right: 10px;
        }
        border-bottom: 1px solid #ead7b9;
        width: 100%;
        .el {
            line-height: 60px;
            height: 60px;
            float: left;
            text-align: center;
        }
        .index {
            .mr();
            text-align: center;
            width: unit(350 / @page-width * 100, vw);
        }
        
        .points {
            float: right;
            margin-right: 15%;
            color: #aa3b31;
        }
    }
}
</style>